import unescape from 'lodash/unescape';

export const encodeEntity = (topic: string) => {
  // encodeURIComponent doesn't handle periods or apostrophes
  return encodeURIComponent(topic).replaceAll('.', '%2E').replaceAll("'", '%27');
};

export const capitalize = (str: string) => {
  return str?.replace(/#/, '').replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};

export const parameterize = (str: string) => {
  return str
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9\s':&]+/g, '')
    .replace(/\s+/g, '-')
    .replace(/[':&]+/g, '-')
    .replace(/-+/g, '-');
};

export const stripHtml = (str: string) => {
  if (!str) return '';
  const htmlRegex = /(<([^>]+)>)/gi;
  return unescape(str.replace(/<br ?\/>/g, '\n')).replace(htmlRegex, '');
};

export const convertMDLinkToHTML = (str: string): string => {
  const linkContent = str?.match(/\[([^\]]+)\]\(([^)]+)\)/);
  if (linkContent) {
    const linkText = linkContent[1];
    const linkHref = linkContent[2];
    const linkHTML = `<a href="${linkHref}" target="_blank" rel="noreferrer" class="underline hover:text-primary-magenta">${linkText}</a>`;
    str = str.replace(linkContent[0], linkHTML);
  }
  return str;
};

export const transformToSnakeCase = (str: string) => {
  return str.replace(' ', '_').toLowerCase();
};

export const formatNumber = (num: number): number => {
  return Number.isInteger(num) ? num : Number(num.toFixed(2));
};
